



















































import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';
import { Subject } from '@/resource/subject/subject.model';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import animateScrollTo from 'animated-scroll-to';
import { dragscroll } from 'vue-dragscroll';

interface SubjectOption {
  uuid: string;
  name: string;
  isActive: boolean;
}

@Component({
  directives: {
    dragscroll,
  },
})
export default class PreCollectionSubject extends Vue {
  @Prop({ required: true })
  queries!: PreCollectionsParams;

  @Prop({ required: true })
  availSubjects!: Subject[];

  @Prop({ required: true })
  isLoading!: boolean;

  @Prop({ required: true })
  isLoadingAddPreCollection!: boolean;

  @Prop()
  initialSubjectUuid!: string;

  subjects: SubjectOption[] = [];
  selectedSubjectIndex = 0;
  isSubjectTypeChange = false;

  showRightArrow = true;
  showLeftArrow = false;
  showArrows = true;

  get isParentLoading() {
    return this.isLoading || this.isLoadingAddPreCollection;
  }

  subjectSlider(): any {
    return document.getElementById('SLIDER-SUBJECT');
  }

  innerSubjectSlider(): any {
    return document.getElementById('INNER-SLIDER-SUBJECT');
  }

  created() {
    this.filterSubjects();
  }

  mounted() {
    if (this.subjectSlider() && this.innerSubjectSlider()) {
      this.subjectSlider().addEventListener('scroll', () => {
        if (this.isSubjectTypeChange) return;

        const currentSliderPosition = this.subjectSlider().scrollLeft;
        const sliderEndPosition =
          this.innerSubjectSlider().offsetWidth -
          this.subjectSlider().offsetWidth;

        if (currentSliderPosition >= sliderEndPosition) {
          this.showLeftArrow = true;
          this.showRightArrow = false;
        } else if (currentSliderPosition <= 0) {
          this.showLeftArrow = false;
          this.showRightArrow = true;
        } else {
          this.showLeftArrow = true;
          this.showRightArrow = true;
        }
      });

      this.updateArrows();

      window.addEventListener('resize', this.updateArrows);
    }
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updateArrows);
  }

  subjectClick(subject: SubjectOption, selectedIndex: number) {
    if (this.isParentLoading) return;

    if (subject.uuid === this.queries.subjectUuid) return;

    const prevSelectedSubject = this.subjects.find(
      subject => subject.uuid === this.queries.subjectUuid,
    );

    if (prevSelectedSubject && prevSelectedSubject.isActive) {
      prevSelectedSubject.isActive = false;
    }

    this.queries.subjectUuid = subject.uuid;
    subject.isActive = true;
    this.selectedSubjectIndex = selectedIndex;

    this.scrollToActiveSubject();
    this.$emit('resetFilters');
    this.$emit('reFetch', true);
  }

  async arrowClick(i: number) {
    if (this.isParentLoading) return;

    let distanceToMove = 0;

    if (i === -1 && this.selectedSubjectIndex > 0) {
      this.selectedSubjectIndex = this.selectedSubjectIndex + i;
    } else if (i === 1) {
      this.selectedSubjectIndex = this.selectedSubjectIndex + i;
    }

    if (this.selectedSubjectIndex > 0) {
      const prevSubjects = [...Array(this.selectedSubjectIndex).keys()];
      prevSubjects.forEach(index => {
        const item: any = document.querySelector(
          `.slider-tab-subject-${index}`,
        );

        if (item) {
          const itemStyle = getComputedStyle(item);
          distanceToMove += item.offsetWidth + parseInt(itemStyle.marginRight);
        }
      });
    }

    const sliderEndPosition =
      this.innerSubjectSlider().offsetWidth - this.subjectSlider().offsetWidth;

    if (i === -1 && distanceToMove > sliderEndPosition) {
      distanceToMove = 0;
    } else {
      distanceToMove -= 24;
    }

    await animateScrollTo([distanceToMove, 0], {
      elementToScroll: this.subjectSlider(),
    });
  }

  filterSubjects() {
    // NOTE: Default index selected subject from list of subjects
    let selectedSubjectIndex = 3;

    if (this.availSubjects && this.availSubjects.length) {
      this.subjects = this.availSubjects
        .filter(subject => {
          return subject.subjectTypes.includes(this.queries.subjectType);
        })
        .map((subject, index) => {
          if (
            this.initialSubjectUuid &&
            subject.uuid === this.initialSubjectUuid
          ) {
            selectedSubjectIndex = index;
          }

          return {
            uuid: subject.uuid,
            name: subject.name,
            isActive: false,
          };
        });
    } else {
      this.subjects = [];
    }
    this.queries.subjectUuid = this.subjects[selectedSubjectIndex].uuid;
    this.subjects[selectedSubjectIndex].isActive = true;
    this.selectedSubjectIndex = selectedSubjectIndex;

    this.$emit('firstFetch');
  }

  updated() {
    if (!this.isSubjectTypeChange) return;
    this.updateArrows();
    this.isSubjectTypeChange = false;
  }

  async updateArrows() {
    const sliderEndPosition =
      this.innerSubjectSlider().offsetWidth - this.subjectSlider().offsetWidth;

    if (sliderEndPosition <= 0 || window.innerWidth <= 640) {
      this.showArrows = false;
    } else {
      this.showArrows = true;
    }

    this.showLeftArrow = false;
    this.showRightArrow = true;

    await this.scrollToActiveSubject();
  }

  async scrollToActiveSubject() {
    const prevSubjects = [...Array(this.selectedSubjectIndex).keys()];
    let distanceToMove = 0;
    prevSubjects.forEach(index => {
      const item: any = document.querySelector(`.slider-tab-subject-${index}`);

      if (item) {
        const itemStyle = getComputedStyle(item);
        distanceToMove += item.offsetWidth + parseInt(itemStyle.marginLeft);
      }
    });

    await animateScrollTo([distanceToMove - 24, 0], {
      elementToScroll: this.subjectSlider(),
    });

    animateScrollTo([distanceToMove - 24, 0], {
      elementToScroll: this.subjectSlider(),
    });
  }

  @Watch('availSubjects')
  onAvailSubjectsChange() {
    this.filterSubjects();
  }

  @Watch('queries.subjectType')
  onSubjectTypeChange() {
    this.isSubjectTypeChange = true;
    this.filterSubjects();
  }
}
